require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-turmeric-lemon-rice.json") })
        }
      }, "path---recipes-turmeric-lemon-rice");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-turmeric-lemon-rice!./.cache/json/recipes-turmeric-lemon-rice.json
// module id = 742
// module chunks = 231608221292675